export default __webpack_public_path__ + "static/best-in-field-1-4ccfac7b8afc68ee0c4492e1257c6b7b.webp";